import qs from "qs";

import { axiosWithAuth, convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";
import { BillingPaymentMethodInfoUpdate } from "types/tsSolution";

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

const listBillingFilters = filters => {
	const {
		eb_mid,
		eb_dba,
		eb_agentOffice,
		eb_agent,
		eb_terminalNumber,
		eb_completedUpdate,
		eb_origin,
		eb_tidNumber,
		eb_ownership,
		eb_manufacture,
		eb_model,
		eb_serial,
		eb_billTo,
		eb_paymentType,
		eb_billingStatus,
		eb_invoiceDate,
		eb_paymentDate,
	} = filters || {};

	return {
		mid: eb_mid,
		dba_name: eb_dba,
		agent_office_name: eb_agentOffice,
		agent_name: eb_agent,
		number: eb_terminalNumber,
		complete_or_update_to: convertDateToISO(eb_completedUpdate?.[1], {
			addTime: TIME_OFFSET_DAY_END,
		}),
		complete_or_update_from: convertDateToISO(eb_completedUpdate?.[0]),
		origin: eb_origin?.value,
		tid_v_number: eb_tidNumber,
		ownership: eb_ownership?.name,
		manufaturer_ids: eb_manufacture?.map(item => item.id),
		model_ids: eb_model?.map(item => item.id),
		serial_number: eb_serial,
		bill_to: eb_billTo?.name,
		payment_type: eb_paymentType?.value,
		billing_status: eb_billingStatus?.name,
		invoice_date_from: convertDateToISO(eb_invoiceDate?.[0]),
		invoice_date_to: convertDateToISO(eb_invoiceDate?.[1], {
			addTime: TIME_OFFSET_DAY_END,
		}),
		payment_date_from: convertDateToISO(eb_paymentDate?.[0]),
		payment_date_to: convertDateToISO(eb_paymentDate?.[1], {
			addTime: TIME_OFFSET_DAY_END,
		}),
	};
};

const mapBillingListParams = ({ page, filters, sortBy }) => ({
	page_index: page,
	page_size: PAGE_SIZE,
	sort_type: sortBy?.id || undefined,
	ascending: sortBy?.id ? sortBy?.desc : undefined,
	// filters
	...listBillingFilters(filters),
});

function getEquipmentBilling({ page, filters, sortBy }) {
	const options = {
		url: `${API_URL}/api/terminal_solutions/billing`,
		params: mapBillingListParams({
			page,
			filters,
			sortBy,
		}),
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function getTerminalSolutionBillingXlxsReport({
	page,
	filters,
	sortBy,
}: {
	page?: number;
	filters?: any;
	sortBy?: any;
}) {
	const params = mapBillingListParams({
		page,
		sortBy,
		filters,
	});

	const user = JSON.parse(localStorage.getItem("user") || "");
	const url = `${API_URL}/api/terminal_solutions/billing/export?token=${
		user.access_token
	}&?${qs.stringify(params, { arrayFormat: "repeat" })}`;
	let link = document.createElement("a");

	link.href = url;

	link.click();
}

function updateBillingPaymentMethodInfo({
	id,
	model,
}: {
	id: string;
	model: BillingPaymentMethodInfoUpdate;
}) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/terminal_solutions/billing/${id}/update_payment_method_info`,
	};

	return axiosWithAuth(options);
}

export const EquipmentBillingService = {
	getEquipmentBilling,
	updateBillingPaymentMethodInfo,
	getTerminalSolutionBillingXlxsReport,
};
